import styled from 'styled-components';

const HalfWidthFilterContainer = styled.div`
  margin-left: 10px;
  width: 39%;
`;

export default HalfWidthFilterContainer;
